import { css } from '@emotion/react'
import styled from '@emotion/styled'

import { Theme } from 'scripts/react-components/themes/Theme'

const wrapperStyles = ({ theme }: Theme) => css`
  label: filters__wrapper;

  [target='card'] {
    ${theme.media.mega} {
      padding: ${theme.spacings.mega} 0;
    }

    & > div {
      padding: 2px ${theme.spacings.mega} 0;
      overflow-y: hidden;
    }
  }
`

export const Wrapper = styled('div')(wrapperStyles)
